<div class="public-organizations-page">
  <HomeNavBar />

  <section :class="{ 'scrollable-container container-fluid px-2 py-2': $route.name === 'public_organization' }">
    <div v-if="loading" class="profile-directory-state">
      <span class="spinner-border text-primary" role="status"></span>
      <p class="mt-3 mb-0">Loading organisations...</p>
    </div>
    <div v-else-if="error" class="container py-4">
      <div class="alert alert-danger">{{ error }}</div>
    </div>

    <div v-else-if="$route.name === 'public_organization' && organization.id">
      <article class="card border-0 shadow-sm rounded overflow-hidden bg-white public-organization-profile">
        <div class="public-organization-cover position-relative overflow-hidden">
          <img v-if="organization.cover_url" :src="organization.cover_url" :alt="`${organization.company_name} cover`">
          <div
            v-else
            class="public-organization-cover-placeholder"
            :style="{ background: `linear-gradient(135deg, ${organization.primary_color || '#123f91'}, ${organization.secondary_color || '#38a3a5'})` }"
          ></div>
          <router-link :to="{ name: 'public_organizations' }" class="btn btn-sm bg-white rounded shadow-sm public-organization-back">
            <i class="bi bi-arrow-left me-1"></i> All organisations
          </router-link>
        </div>

        <div class="card-body pt-0 px-3 px-xl-4 pb-4">
          <div class="public-organization-profile-row">
            <div class="public-organization-avatar bg-white rounded-circle shadow-lg p-1 border border-2 border-white">
              <img v-if="organization.logo_url" :src="organization.logo_url" :alt="`${organization.company_name} logo`">
              <span v-else>{{ get_initials(organization) }}</span>
            </div>

            <div class="public-organization-profile-copy">
              <div class="d-flex align-items-center gap-2 flex-wrap justify-content-center justify-content-xl-start">
                <h1 class="h3 fw-bold text-dark mb-0">{{ organization.company_name }}</h1>
                <span class="badge bg-primary-subtle text-primary rounded-pill">Public organisation</span>
              </div>
              <p v-if="organization.type_of_organization" class="text-muted text-capitalize mb-1">
                {{ format_type(organization.type_of_organization) }}
              </p>
              <p v-if="organization.location" class="text-muted mb-0">
                <i class="bi bi-geo-alt-fill me-1 text-primary"></i>{{ organization.location }}
              </p>
            </div>

            <div class="public-organization-profile-action">
              <button v-if="is_authenticated" class="btn btn-primary rounded px-4" :disabled="joining" @click="join_organization">
                <span v-if="joining" class="spinner-border spinner-border-sm me-2"></span>
                {{ joining ? 'Joining...' : 'Join organisation' }}
              </button>
              <div v-else class="d-flex flex-wrap gap-2">
                <router-link :to="personal_registration_route" class="btn btn-primary rounded" @click="remember_return_path">
                  Create personal account
                </router-link>
                <router-link :to="login_route" class="btn btn-outline-primary rounded" @click="remember_return_path">
                  Login to join
                </router-link>
              </div>
            </div>
          </div>

          <div class="public-organization-about border-top mt-4 pt-4">
            <h2 class="h5 fw-bold">About</h2>
            <p class="text-muted mb-0">{{ organization.description || 'No description has been provided.' }}</p>
          </div>
        </div>
      </article>
    </div>

    <div v-else>
      <main class="profile-directory-page profile-directory-page-organizations">
        <section class="profile-directory-toolbar">
          <div class="profile-directory-search">
            <i class="bi bi-search" aria-hidden="true"></i>
            <input
              v-model="query"
              type="text"
              class="form-control"
              placeholder="Search organisations"
            >
            <button
              v-if="query"
              type="button"
              class="profile-directory-clear d-inline-flex align-items-center justify-content-center"
              aria-label="Clear search"
              @click="clear_search"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>
        </section>

        <section v-if="filtered_organizations.length" class="profile-directory-grid">
          <article
            v-for="item in filtered_organizations"
            :key="item.id"
            class="profile-directory-card"
          >
            <div class="profile-directory-card-top">
              <img
                v-if="item.logo_url"
                :src="item.logo_url"
                :alt="`${item.company_name} logo`"
                class="profile-directory-avatar"
              >
              <span
                v-else
                class="profile-directory-avatar profile-directory-avatar-fallback d-inline-flex align-items-center justify-content-center"
                aria-hidden="true"
              >
                {{ get_initials(item) }}
              </span>

              <span class="profile-directory-status d-inline-flex align-items-center gap-1">
                <i class="bi bi-buildings-fill" aria-hidden="true"></i>
                Public
              </span>
            </div>

            <div class="profile-directory-card-body">
              <h5 class="profile-directory-name">{{ item.company_name }}</h5>
              <div class="profile-directory-detail-list">
                <span v-if="item.type_of_organization" class="profile-directory-detail text-capitalize">
                  <i class="bi bi-briefcase-fill" aria-hidden="true"></i>
                  {{ format_type(item.type_of_organization) }}
                </span>
                <span v-if="item.location" class="profile-directory-detail">
                  <i class="bi bi-geo-alt-fill" aria-hidden="true"></i>
                  {{ item.location }}
                </span>
              </div>
            </div>

            <button type="button" class="btn profile-directory-action" @click="open_organization(item)">
              <span>View Profile</span>
              <i class="bi bi-arrow-right" aria-hidden="true"></i>
            </button>
          </article>
        </section>

        <section v-else class="d-flex flex-column align-items-center justify-content text-center profile-directory-empty">
          <span class="profile-directory-empty-icon d-inline-flex align-items-center justify-content-center">
            <i class="bi bi-building-x" aria-hidden="true"></i>
          </span>
          <h5>No organisations found</h5>
          <p>No matching public organisations are available.</p>
        </section>
      </main>
    </div>
  </section>
</div>
